import {
  DELETE_CURRENCY,
  PUT_CURRENCY,
    GET_CURRENCY,
    POST_CURRENCY,
  } from "../constants/actionTypes";

  const defaultState = {
    currency:[],
  };

  let data = [];
  export default (state = defaultState, action) => {
    try {
      switch (action.type) {
        case GET_CURRENCY:
          return {...state,currency:[...action.payload]};
        case POST_CURRENCY:
          return {...state,currency:[...state?.currency,action.payload]};
        case PUT_CURRENCY:
          data = [...state?.currency];
          const index = data?.findIndex(
            (setting) => setting?.currency_id === action.payload?.currency_id,
          );
          if (index != -1) data[index] = { ...action?.payload };
          return {...state,currency: [...data]};
        case DELETE_CURRENCY:
          const updatedArr = [...state?.currency].filter(
            (setting) => setting.currency_id !== action.payload,
          );
          return {...state,currency: [...updatedArr]};
        default:
          return state;
      }
    } catch (error) {
      throw new Error(error);
    }
  };